module.exports = __webpack_public_path__ + "static/img/zfb.dda4bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zfb.png
// module id = /rlq
// module chunks = 4